
(function () {
  var list = document.querySelector('.msb-toc ol');
  if (!list) return;

  // The Liquid template ships an empty list and lets us build it from the
  // rendered body's own headings, so the contents can never drift from the
  // article. The preview ships it pre-populated; either way we continue.
  if (!list.querySelector('a')) {
    // Headings live in the body wrapper. Today's plain body has no ids, so we
    // add them — the contents rail must work on the content that exists now,
    // not only on our own richer output.
    var found = document.querySelectorAll('.msb-body h2, .msb-article h2');
    found = Array.prototype.filter.call(found, function (h) {
      return h.textContent.trim().length > 0;
    });
    found.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').slice(0, 40).replace(/-+$/, '');
      }
    });
    if (found.length < 2) {
      // Removed, not hidden. The grid gives a column to any shell that CONTAINS
      // a rail, so a display:none aside would still reserve 232px and leave the
      // article sitting left of the page's centre beside an empty gap.
      var aside = document.querySelector('.msb-toc');
      if (aside && aside.parentNode) aside.parentNode.removeChild(aside);
      return;
    }
    found.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  var links = list.querySelectorAll('a');
  if (!links.length) return;

  function setActive(id) {
    var target = null;
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('active', on);
      if (on) target = a;
    });
    // Move one marker rather than restyling the active link: changing
    // font-weight or adding a border would reflow the rail on every scroll.
    // The marker is the ol's ::before, reached through custom properties —
    // a pseudo-element cannot be a DOM child of <ol> and a real element may
    // not be one either.
    if (target) {
      list.style.setProperty('--toc-marker-y', target.offsetTop + 'px');
      list.style.setProperty('--toc-marker-h', target.offsetHeight + 'px');
    }
  }

  var heads = [];
  links.forEach(function (a) {
    var el = document.getElementById(a.getAttribute('href').slice(1));
    if (el) heads.push(el);
  });
  if (!heads.length) return;

  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
    }, { rootMargin: '0px 0px -70% 0px' });
    heads.forEach(function (h) { spy.observe(h); });
  }
  setActive(heads[0].id);
})();
